module.exports = __webpack_public_path__ + "img/food_08.d0cc328c.jpg";